import React from "react";
import moment from "moment";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyPlanDetails({ sections = {}, plan = {}, context = {} }) {
  const safeContext = context || {};
  const projectDetails = sections.document_project_details && sections.document_project_details.data
    ? sections.document_project_details.data
    : {};
  const planNumber = plan.document_number || <span>&mdash;</span>;
  const linkedDocuments = Array.isArray(plan.linked_documents)
    ? plan.linked_documents
    : [];
  const procedures = linkedDocuments
    .filter((document) => document && document.checked === true && document.document_number)
    .map((document) => document.document_number)
    .join("; ");
  const category = plan.category && typeof plan.category === "object"
    ? plan.category.category_name
    : (plan.category_name || plan.category || "");
  const rescueReadiness = safeContext.previewMode
    ? (projectDetails.swms_number ? `${projectDetails.swms_number}-RDY` : "")
    : (safeContext.rescueReadinessDocumentNumber
      || plan.rescue_readiness
      || plan.rescue_readiness_reference
      || "");
  const effectiveDate = projectDetails.issue_date
    ? moment.utc(projectDetails.issue_date).format("DD/MM/YYYY")
    : "";
  const displayValue = (value) => value || <span>&mdash;</span>;
  const status = safeContext.approvalStatus
    ? (safeContext.approvalStatus === "APPROVED" ? "Approved" : "Pending")
    : (plan.status || "Approved");

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span
          className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`}
          style={{ background: "#e9c84a", color: "#1f1031" }}
        >
          1
        </span>
        Emergency Plan Details
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewSectionSubHead}>Document Identity</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Emergency Plan ID</span>
                <span className={styles.PreviewValue}>{planNumber}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Revision</span>
                <span className={styles.PreviewValue}>{displayValue(plan.revision || plan.version || projectDetails.swms_version)}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Status</span>
                <span className={styles.PreviewValue}>{status}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Category</span>
                <span className={styles.PreviewValue}>{displayValue(category)}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={styles.PreviewSectionSubHead}>Linked Documents &amp; Work Context</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Linked SWMS</span>
                <span className={styles.PreviewValue}>{displayValue(projectDetails.swms_number)}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>SWMS Name</span>
                <span className={styles.PreviewValue}>{displayValue(projectDetails.swms_name)}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Applicable Procedures</span>
                <span className={styles.PreviewValue}>{displayValue(procedures)}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Rescue Readiness</span>
                <span className={styles.PreviewValue}>{displayValue(rescueReadiness)}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Site Name</span>
                <span className={styles.PreviewValue}>{displayValue(projectDetails.site_name)}</span>
              </td>
              <td colSpan={2}>
                <span className={styles.PreviewLabel}>Site Address</span>
                <span className={styles.PreviewValue}>{displayValue(projectDetails.site_address)}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Effective Date</span>
                <span className={styles.PreviewValue}>{displayValue(effectiveDate)}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
